var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3712 11.3713C18.7854 11.9571 17.8357 11.9571 17.2499 11.3713L10.3105 4.43199L3.37121 11.3713C2.78542 11.9571 1.83567 11.9571 1.24989 11.3713C0.664101 10.7855 0.664101 9.83579 1.24989 9.25001L10.3105 0.189347L19.3712 9.25001C19.957 9.8358 19.957 10.7855 19.3712 11.3713Z",
    fill: "#F5F6F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpIcon);
export default __webpack_public_path__ + "static/media/arrowUpIcon.a1e892dbd42afe5ede7002f6c67760fb.svg";
export { ForwardRef as ReactComponent };